import '../vendor/jquery-select';
import common from './_common';
common();

$(function(){
    if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function() {
            let $recaptcha = $('#j-recaptcha-token-contact-form');
            grecaptcha.execute($recaptcha.attr('data-key'), {action: 'contact'}).then(function(token) {
                $recaptcha.val(token);
            });
        });
    }

    if ($('#inquiryType').length) {
        $('#inquiryType').selectOverlap();
    }

    $('#dsaContactForm').on('submit', function(e){
        e.preventDefault();
        let $this = $(this);
        if (!formValidation()) {
            return false;
        }

        $.ajax({
            url: $this.attr('action'),
            type: $this.attr('method'),
            timeout: 15000,
            data: $(this).serialize(),
            success: function() {
                window.location = '/contact?sent=true';
            },
            error: function() {
                $('.j-submit-error').removeClass('hide');
            }
        });
    });

    function formValidation() {
        let $email = $('#email');
        let $inquiryType = $('#inquiryType');
        let error = false;
        let $fieldset;
        $('fieldset.error').removeClass('error');
        $('.j-label-valid').show();
        $('.j-label-error').hide();
        $('.recaptcha-error').hide();
        let filter = /[^\s@]+@[^\s@]+\.[^\s@]+/;
        if (!filter.test($email.val())) {
            $fieldset = $email.parents('fieldset');
            $fieldset.addClass('error');
            $fieldset.find('.j-label-valid').hide();
            $fieldset.find('.j-label-error').show();
            error = true;
        }
        if (!$inquiryType.val()) {
            $fieldset = $inquiryType.parents('fieldset');
            $fieldset.addClass('error');
            $fieldset.find('.j-label-valid').hide();
            $fieldset.find('.j-label-error').show();
            error = true;
        }
        return !error;
    }
});